import React from 'react';
// import { useStoreState } from 'easy-peasy';
import qs from 'querystringify';

import Layout from '../../../components/global/Layout';
import Details from './Details';

import Header from './Header';
import { Loading, Pagination } from '../../../components/elements';
import { useCmsData } from './helpers';
import Search from './Search';

const LISTSIZE = 50;

const CmsData = ({ location, history }) => {
  const routeState = qs.parse(location.search);
  const { name, status, page, cmsDataType } = routeState;

  let nameFilter = null;

  if (name) {
    nameFilter = name;
  }

  let statusFilter = 'ACTIVE';

  if (status) {
    statusFilter = status;
  }

  let cmsDataTypeFilter = null;

  if (cmsDataType) {
    cmsDataTypeFilter = cmsDataType;
  }

  const currentPage = parseInt(page, 10) - 1 >= 0 ? parseInt(page, 10) - 1 : 0;

  const { loading, pageCount, totalElements, cmsData, refetch } = useCmsData({
    id: '',
    name: nameFilter,
    status: statusFilter,
    from: currentPage * LISTSIZE,
    size: LISTSIZE,
    sort: 'UPDATED_DESC',
    cmsDataType: cmsDataTypeFilter,
  });

  const [selectedCmsData, setSelectedCmsData] = React.useState(null);
  const [isActiveModal, setIsActiveModal] = React.useState(false);

  const activeModalProp = {
    selectedCmsData,
    setSelectedCmsData,
    isActiveModal,
    setIsActiveModal,
  };

  return (
    <Layout>
      <Header
        setSelectedCmsData={setSelectedCmsData}
        setIsActiveModal={setIsActiveModal}
      />
      <Search
        name={nameFilter}
        status={statusFilter}
        routeState={routeState}
        cmsDataType={cmsDataType}
      />
      {loading && <Loading />}

      {!loading && cmsData && cmsData?.length !== 0 && (
        <div>
          {totalElements > 0 && (
            <Pagination
              pageFrom={currentPage * LISTSIZE}
              pageCount={pageCount}
              listSize={LISTSIZE}
              totalElements={totalElements}
              currentPage={currentPage}
              handlePageClick={value => {
                history.push(
                  `/cms-data${qs.stringify(
                    {
                      ...routeState,
                      page: value.selected + 1,
                    },
                    true,
                  )}`,
                );
              }}
            />
          )}
          <Details
            cmsData={cmsData}
            activeModalProp={activeModalProp}
            refetch={refetch}
          />
        </div>
      )}
    </Layout>
  );
};

export default CmsData;
